// extracted by mini-css-extract-plugin
export default {"main":"LinkButton_main__zc2Y5","icon":"LinkButton_icon__18Iaz","disabled":"LinkButton_disabled__PjZID"};